module.exports = __webpack_public_path__ + "img/title-2.5337b141.png";